/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    let page = this.modelFor('page').page;
    // assessment_ids is a StatefulArray, which JSON.stringify can't write as
    // an array; copy it to a plain array first.
    let assessments = [...page.assessment_ids];
    let promises = {
      page,
    };
    if (assessments.length > 0) {
      let assessmentIds = JSON.stringify(assessments);
      promises = {
        page,
        assessments: store.query('assessments/assessment', { assessmentIds }),
        modules: store.query('assessments/module', {
          assessmentIds,
          include: 'gradeSchedules',
        }),
        grades: store.query('assessments/grade', { assessmentIds }),
      };
    }

    return hash(promises);
  }
}
